window.addEventListener('load', function () {
  const carousels = document.querySelectorAll('.custom-carousel .carousel-container');

  carousels.forEach(container => {
    const track = container.querySelector('.carousel-track');
    const slides = Array.from(track.children);
    const prev = container.querySelector('.prev');
    const next = container.querySelector('.next');

    let currentIndex = 0;

    function updateCarousel() {
      const containerWidth = container.offsetWidth;

      // Реальна ширина слайда з margin
      let slideWidth;
      if (window.innerWidth <= 767) {
        const style = getComputedStyle(slides[0]);
        const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
        slideWidth = slides[0].offsetWidth + margin;
      } else {
        slideWidth = slides[0].offsetWidth + 10; // padding десктоп
      }

      let offset;

      if (window.innerWidth <= 767) {
        // Центрування поточного слайда
        offset = currentIndex * slideWidth - (containerWidth - slideWidth)/2;
      } else {
        // Десктоп
        offset = 0;
        for (let i = 0; i < currentIndex; i++) {
          offset += slides[i].offsetWidth + 10;
        }
      }

      const maxOffset = track.scrollWidth - containerWidth;
      const finalOffset = Math.min(Math.max(offset, 0), maxOffset);

      track.style.transform = `translateX(${-finalOffset}px)`;
    }

    prev.addEventListener('click', () => {
      if (currentIndex > 0) currentIndex--;
      updateCarousel();
    });

    next.addEventListener('click', () => {
      if (currentIndex < slides.length - 1) currentIndex++;
      updateCarousel();
    });

    window.addEventListener('resize', updateCarousel);
    updateCarousel();
  });
});
